import "./RadioButtonV2.scss";

const RadioButtonV2 = ({
  name,
  id,
  checked,
  value,
  onChange,
  label = "",
  disabled = false,
}) => {
  return (
    <label className="custom-radio-v2" htmlFor={id}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
      />
      <span className="custom-radio-v2__circle"></span>
      {label && <span className="custom-radio-v2__label">{label}</span>}
    </label>
  );
};

export default RadioButtonV2;
